import {
  isInEmbedVisibilityHideExperimentVariant,
  isInFireworkVisibilityHideExperimentVariant,
} from '@core/abTesting/backend/backendABTesting'
import { logABTestingInfo } from '@core/abTesting/logging'
import { getFWN } from '@core/fwn'
import type { IStoryblockParams } from '@core/types'
import { IS_SOFT_PIP_STATE_PROCESSED } from '@player/features/pictureInPicture/constants'
import { clearPersistedPlayerState } from '@player/features/pictureInPicture/storage'

import { FWNElement } from './bases/FWNElement'

class StoryblockElement extends FWNElement {
  height = '75vh'
  width = '100%'

  override render(): void {
    let params = {
      height: this.height,
      width: this.width,
      ...this.getAttributes(),
    }

    const fwn = getFWN()

    // Setting it to 1vh to avoid the storyblock from being visible but still
    // trigger the visibility observer for tracking purposes.
    const isInHideExperimentVariant = isInEmbedVisibilityHideExperimentVariant()
    const isInFireworkVisibilityHideVariant =
      isInFireworkVisibilityHideExperimentVariant()

    logABTestingInfo('isInHideExperimentVariant', isInHideExperimentVariant)
    logABTestingInfo(
      'isInFireworkVisibilityHideVariant',
      isInFireworkVisibilityHideVariant,
    )
    if (isInHideExperimentVariant || isInFireworkVisibilityHideVariant) {
      params = {
        ...params,
        height: '1vh',
      }
    }

    if (
      fwn &&
      !fwn[IS_SOFT_PIP_STATE_PROCESSED] &&
      (params as IStoryblockParams).clear_player_state
    ) {
      fwn[IS_SOFT_PIP_STATE_PROCESSED] = true
      clearPersistedPlayerState()
    }

    const computedHeight = parseInt(getComputedStyle(this).height)
    const computedWidth = parseInt(getComputedStyle(this).width)
    this.setSpaceReservingStyle(
      'height',
      computedHeight ? getComputedStyle(this).height : params.height,
    )
    this.style.width = computedWidth
      ? getComputedStyle(this).width
      : params.width // Explicitly set width to force wrapping flex-box to respect it.

    import('@embed/storyblockRender').then(({ storyblockRender }) => {
      if (this.shadowRoot) {
        storyblockRender({
          target: this.shadowRoot,
          widgetId: this.widgetId,
          widgetParams: params,
        })
      }
    })
  }
}

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'fw-storyblock': Record<string, string>
    }
  }
}

if (!customElements.get('fw-storyblock')) {
  customElements.define('fw-storyblock', StoryblockElement)
}
